const STORAGE_JSON_CACHE = "offline-storage-json-v1";

/**
 * Fetches a JSON file from Cloud Storage. Online it saves the response; offline (or if storage
 * can't be reached) it returns the last copy saved while online.
 */
export async function fetchStorageJson<T>(url: string, useCacheBuster = true): Promise<T> {
  const cacheKey = new Request(url); // one stable key, without the cache buster
  try {
    const response = await fetch(useCacheBuster ? `${url}?b=${Date.now()}` : url);
    if (!response.ok) throw new Error(`${url}: HTTP ${response.status}`);
    try {
      const cache = await caches.open(STORAGE_JSON_CACHE);
      await cache.put(cacheKey, response.clone());
    } catch {
      /* Cache Storage unavailable (private window etc.) */
    }
    return (await response.json()) as T;
  } catch (error) {
    try {
      const cache = await caches.open(STORAGE_JSON_CACHE);
      const cached = await cache.match(cacheKey);
      if (cached) return (await cached.json()) as T;
    } catch {
      /* no saved copy */
    }
    throw error;
  }
}
